<template>
  <div class="user-template">
    <el-row class="dialogItem">
      <span>角色性别</span>
      <el-select v-model="userData.sex" style="width: 400px" placeholder="请选择" clearable>
        <el-option key="-1" label="全部" value="-1"> </el-option>
        <el-option key="0" label="女性" value="0"> </el-option>
        <el-option key="1" label="男性" value="1"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>自定义用户ID</span>
      <el-input type="text" v-model="userData.userGroup" style="width: 400px"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span>用户等级</span>
      <el-input type="text" :disabled="isLevel" style="width: 400px" @input="changeDate"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span>会员</span>
      <el-select v-model="userData.vip" style="width: 400px" placeholder="请选择" @input="changeDate" clearable>
        <el-option key="1" label="会员" :value="1"> </el-option>
        <el-option key="0" label="非会员" :value="0"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>充值</span>
      <el-select v-model="userData.pay" style="width: 400px" placeholder="请选择" @input="changeDate" clearable>
        <el-option key="1" label="已充值" value="1"> </el-option>
        <el-option key="0" label="未充值" value="0"> </el-option>
      </el-select>
    </el-row>
    <el-row>
      <p style="margin-left: 50px;">(金币最大值为:2147483647)</p>
    </el-row>
    <el-row class="dialogItem">
      <span>最近新用户注册天数</span>
      <el-select v-model="userData.newByRegisterSymbol" style="width: 100px;margin-right: 10px">
        <el-option label="≤" :value="1"></el-option>
        <el-option label="≥" :value="2"></el-option>
      </el-select>
      <el-input v-model="userData.newByRegister" type="number" style="width: 290px"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span>版本号限制</span>
      <el-select v-model="userData.verSymbol" style="width: 100px;margin-right: 10px">
        <el-option label="≤" :value="1"></el-option>
        <el-option label="≥" :value="2"></el-option>
      </el-select>
      <el-input v-model="userData.verLimit" type="number" style="width: 290px"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span>成功充值的时间</span>
      <el-select v-model="userData.lastRechargeTimeSymbol" style="width: 100px;margin-right: 10px">
        <el-option label="<" :value="1"></el-option>
        <el-option label=">" :value="2"></el-option>
      </el-select>
      <el-date-picker v-model="userData.lastRechargeTime" type="datetime" value-format="timestamp" placeholder="选择日期时间">
      </el-date-picker>
    </el-row>
    <el-row class="dialogItem">
      <span>用户来源渠道</span>
      <el-select v-model="userData.registerSource" style="width: 400px" placeholder="请选择" clearable>
        <el-option v-for="item in userChannelList" :key="item.value" :label="item.name"
          :value="item.value"></el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>手机型号列表</span>
      <el-checkbox v-model="localIsPhoneModels" style="margin-right: 10px">排除手机型号</el-checkbox>
      <el-select v-model="userData.phoneModels" collapse-tags multiple filterable allow-create style="width: 400px" placeholder="请选择" clearable>
        <el-option v-for="(item,index) in phoneModels" :key="index" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>会员等级</span>
      <el-select v-model="userData.memberGrade" style="width: 400px" placeholder="请选择" clearable>
        <el-option v-for="(item, index) in vipLevelList" :key="index" :label="item" :value="item"></el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>消费金额(最近180天)</span>
      <el-input v-model="userData.consumeGold[0]" @input="changeDate" style="width: 180px; margin-right: 10px" oninput="if(value){value=value.replace(/[^\d]/g,1);
 if(Number(value)<=0){value=0}} if(Number(value)>2147483647){value=2147483647}"></el-input>
      <span class="to"> ~ </span>
      <el-input v-model="userData.consumeGold[1]" @input="changeDate" style="width: 180px" oninput="if(value){value=value.replace(/[^\d]/g,1);
 if(Number(value)<=0){value=0}} if(Number(value)>2147483647){value=2147483647}"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span>充值金额</span>
      <el-input v-model="userData.rechargeAmount[0]" @input="changeDate" style="width: 180px; margin-right: 10px"
        oninput="if(value){value=value.replace(/[^\d]/g,1);
 if(Number(value)<=0){value=0}} if(Number(value)>2147483647){value=2147483647}"></el-input>
      <span class="to"> ~ </span>
      <el-input v-model="userData.rechargeAmount[1]" @input="changeDate" style="width: 180px" oninput="if(value){value=value.replace(/[^\d]/g,1);
 if(Number(value)<=0){value=0}} if(Number(value)>2147483647){value=2147483647}"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span>累计充值金币数</span>
      <el-input v-model="userData.rechargeGold[0]" @input="changeDate" style="width: 180px; margin-right: 10px" oninput="if(value){value=value.replace(/[^\d]/g,1);
 if(Number(value)<=0){value=0}} if(Number(value)>2147483647){value=2147483647}"></el-input>
      <span class="to"> ~ </span>
      <el-input v-model="userData.rechargeGold[1]" @input="changeDate" style="width: 180px" oninput="if(value){value=value.replace(/[^\d]/g,1);
 if(Number(value)<=0){value=0}} if(Number(value)>2147483647){value=2147483647}"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span>累积充值美金数</span>
      <el-input v-model="userData.recentRechargeUsd[0]" @input="changeDate" style="width: 180px; margin-right: 10px"
        oninput="if(value){value=value.replace(/[^\d]/g,1);
 if(Number(value)<=0){value=0}} if(Number(value)>2147483647){value=2147483647}"></el-input>
      <span class="to"> ~ </span>
      <el-input v-model="userData.recentRechargeUsd[1]" @input="changeDate" style="width: 180px" oninput="if(value){value=value.replace(/[^\d]/g,1);
 if(Number(value)<=0){value=0}} if(Number(value)>2147483647){value=2147483647}"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span> 最近多少天的充值:</span>
      <el-input v-model="userData.recentRechargeDays" type="number" style="width: 400px"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span>注册时间</span>
      <el-date-picker style="width: 400px" v-model="userData.registerTime" type="daterange" range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" :unlink-panels="true"
        @input="changeDate">
      </el-date-picker>
    </el-row>
    <el-row class="dialogItem">
      <span>流失时间</span>
      <el-input v-model="userData.lostTime" style="width: 400px"></el-input>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'UserTemplate',
  props: {
    userData: {
      type: Object,
      default: () => ({
        sex: '',
        userGroup: '',
        vip: '',
        pay: '',
        registerSource: 0,
        memberGrade: '',
        newByRegister: '',
        newByRegisterSymbol: 1,
        lastRechargeTimeSymbol: 1,
        lastRechargeTime: '',
        recentRechargeDays: '',
        verSymbol: 1,
        verLimit: '',
        consumeGold: ['', ''],
        rechargeAmount: ['', ''],
        rechargeGold: ['', ''],
        recentRechargeUsd: ['', ''],
        registerTime: '',
        lostTime: '',
      })
    },
    userChannelList: {
      type: Array,
      default: () => [
        { name: '全部', value: 0 },
        { name: '自然注册', value: 1 },
        { name: '推广渠道', value: 2 },
      ]
    },
    vipLevelList: {
      type: Array,
      default: () => ['vip1', 'vip2', 'vip3']
    },
    phoneModels: {
      type: Array,
      default: () => []
    },
    isLevel: {
      type: Boolean,
      default: true
    },
    isPhoneModels: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localIsPhoneModels: {
      get() {
        return this.isPhoneModels
      },
      set(value) {
        this.$emit('changeIsPhoneModels', value)
      }
    }
  },
  methods: {
    changeDate() {
      this.$emit('changeDate')
    }
  }
}
</script>

<style scoped lang="scss">
.dialogItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  text-align: left;
  padding-left: 50px;
  color: #000;

  >span {
    width: 160px;
    margin-right: 10px;
    text-align: right;
    font-size: 15px;
    font-weight: bold;

    &.to {
      width: 50px;
      text-align: center;
    }
  }
}
</style> 